import { PER_PAGE } from 'modules/InputViewer/utils/constants';

export const getPageNumberByIndex = (index?: number): number | undefined => {
  if (index !== undefined && index >= 0) {
    const remainder = index % PER_PAGE;
    const page = Math.ceil(index / PER_PAGE);

    // If `remainder` is 0, it means we are on a page that is a multiple of `PER_PAGE`,
    // meaning there was a page change.
    return remainder === 0 ? page + 1 : page;
  }

  return undefined;
};

export const getInputPagedIndex = (index?: number): number | undefined => {
  if (index !== undefined && index >= 0) {
    return index % PER_PAGE;
  }
  return undefined;
};
